import { apiFormRequest, apiRequest } from "@/apis/client";
import type {
  AIApp,
  AIAppPayload,
  AIAppUploadIconResponse,
  UserApplication,
} from "@/apis/types";

export const applicationsApi = {
  listForUser(): Promise<UserApplication[]> {
    return apiRequest<UserApplication[]>("/applications");
  },

  listAll(): Promise<AIApp[]> {
    return apiRequest<AIApp[]>("/admin/applications");
  },

  create(payload: AIAppPayload): Promise<AIApp> {
    return apiRequest<AIApp>("/admin/applications", "POST", payload);
  },

  update(appName: string, payload: Omit<AIAppPayload, "appName">): Promise<AIApp> {
    return apiRequest<AIApp>(`/admin/applications/${appName}`, "PUT", payload);
  },

  remove(appName: string): Promise<void> {
    return apiRequest<void>(`/admin/applications/${appName}`, "DELETE");
  },

  uploadIcon(file: File): Promise<AIAppUploadIconResponse> {
    const formData = new FormData();
    formData.append("file", file);
    return apiFormRequest<AIAppUploadIconResponse>(
      "/admin/applications/upload-icon",
      formData,
      "POST"
    );
  },
};
